import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sales-order-comments-dialog',
  templateUrl: './sales-order-comments-dialog.component.html',
  styleUrls: ['./sales-order-comments-dialog.component.scss']
})
export class SalesOrderCommentsDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any[],
  ) { }

  ngOnInit() {
  }

}
